// 🔥 Run only once per page load
if (!window.__PRELOADER_INIT__) {

  window.__PRELOADER_INIT__ = true;

  document.addEventListener("DOMContentLoaded", () => {

    const preloader = document.getElementById("video-preloader");
    const video = document.getElementById("loader-video");

    if (!preloader) return;

    // 🔒 disable scroll immediately
    document.body.style.overflow = "hidden";

    // ▶️ play video (optional)
    video?.play().catch(()=>{});

    // 🔥 ALWAYS 4 seconds
    setTimeout(() => {

      // 🎬 shrink animation
      video?.classList.add("shrink");

      setTimeout(() => {

        preloader.style.transition = "opacity 0.8s ease";
        preloader.style.opacity = "0";

        setTimeout(() => {
          preloader.style.display = "none";

          // 🔓 enable scroll
          document.body.style.overflow = "";

        }, 800);

      }, 700);

    }, 4000);

  });
}